import React, { useEffect, useMemo, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { ButtonPrimary } from "../../../../Components/Button";
import Loading from "../../../../Components/Loading";
import { token } from "../../../../modules/auth";
import { Input, Succeeded } from "../../../../Components/Form";
import { Select } from "../../../../ui";

let VenueFinancialsForm = ({
  handleSubmit,
  submitting,
  countries,
  submitSucceeded,
  onSubmit,
  hideEmail = false,
  isModal = false,
}) => {
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (submitSucceeded) {
      setShowSuccess(true);
      const timeout = setTimeout(() => {
        setShowSuccess(false);
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [submitSucceeded]);

  const getCountryOptions = useMemo(() => {
    let options = [];
    if (countries && Object.entries(countries).length > 0) {
      countries.sort((a, b) => a.name.localeCompare(b.name));
      countries.map(country => {
        options.push({
          text: country.name,
          value: country.id,
        });
      });
      options.forEach(function(country, i) {
        if (country.text === "United Kingdom") {
          options.splice(i, 1);
          options.unshift(country);
        }
      });
    }
    return options;
  }, [countries]);

  return (
    <form className="border-none max-w-4xl" onSubmit={handleSubmit(onSubmit)}>
      {!hideEmail && (
        <div className="mb-8">
          <Field
            name="invoice_email"
            label="Invoice Email"
            component={Input}
            type="email"
            wrapperClassName="mb-4"
          />
        </div>
      )}

      <div className="bg-gray-50 rounded-lg pt-6 mb-6">
        <div className="space-y-4">
          <Field
            name="invoice_recipient"
            label="Invoice Recipient"
            component={Input}
            wrapperClassName="mb-4"
          />
          <Field
            name="address.address1"
            label="Address 1"
            component={Input}
            wrapperClassName="mb-4"
          />
          <Field
            name="address.address2"
            label="Address 2"
            component={Input}
            wrapperClassName="mb-4"
          />
          <Field
            name="address.address3"
            label="Address 3"
            component={Input}
            wrapperClassName="mb-4"
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              name="address.city"
              label="City"
              component={Input}
              wrapperClassName="mb-4"
            />
            <Field
              name="address.county"
              label="County"
              component={Input}
              wrapperClassName="mb-4"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              name="address.postcode"
              label="Postcode"
              component={Input}
              wrapperClassName="mb-4"
            />
            <Field
              name="address.country_id"
              label="Country"
              component={Select}
              options={getCountryOptions}
            />
          </div>
        </div>
      </div>

      {showSuccess && <Succeeded />}
      <div className="flex items-center gap-3 mt-6">
        <ButtonPrimary type="submit">
          {submitting ? <Loading inline /> : "Save"}
        </ButtonPrimary>
      </div>
    </form>
  );
};
const mapStateToProps = (state, props) => {
  let initialValues = {
    ...state.venueFinancials.venueFinancials,
    invoice_recipient: state?.venueFinancials?.venueFinancials?.invoice_recipient ? state.venueFinancials.venueFinancials.invoice_recipient: (props.venue?.name ?props.venue?.name  : ''),

  };
  return {
    form: props.form,
    initialValues,
    token: token(state),
    ...state.countries,
  };
};

const mapDispatchToProps = {};

VenueFinancialsForm = reduxForm({
  enableReinitialize: true,
})(VenueFinancialsForm);

VenueFinancialsForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(VenueFinancialsForm);

export default VenueFinancialsForm;
